module.exports = __webpack_public_path__ + "media/images/svg/language-icon-a88501a12b0a69ecc7244cebbaf1e316.svg";